var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"select-pup-box"},[_c('div',{staticClass:"select-box hide-scrollbar"},_vm._l((_vm.list),function(item){return _c('p',{on:{"click":function($event){return _vm.selectType(item)}}},[_vm._v(_vm._s(item.name))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }